import {createStore} from 'vuex'

export default createStore({
    state: {
        token: "",
        user: null
    },
    getters: {
        getToken: (state) => state.token,
        getUser: (state) => state.user
    },
    mutations: {
        setToken(state, token) {

            state.token = token
        },
        setUser(state, user) {

            state.user = user
        }
    },
    actions: {},
    modules: {}
})
